import { useState } from 'react'
import { downloadZip } from '../api/documents'
import { Button } from '../components/Button'
import { buildZipFileName } from '../utils/sanitizeFileName'
import styles from './DownloadSection.module.css'

interface DownloadSectionProps {
  projectId: string
  projectName?: string
  projectAddress?: string | null
}

export function DownloadSection({ projectId, projectName, projectAddress }: DownloadSectionProps) {
  const [state, setState] = useState<'idle' | 'downloading' | 'error'>('idle')

  const handleDownloadZip = async () => {
    setState('downloading')
    try {
      const blob = await downloadZip(projectId)
      const url = URL.createObjectURL(blob)
      const a = window.document.createElement('a')
      a.href = url
      a.download = buildZipFileName(projectName ?? '', projectAddress)
      a.click()
      URL.revokeObjectURL(url)
      setState('idle')
    } catch {
      setState('error')
    }
  }

  return (
    <div className={styles.wrapper}>
      {state === 'error' && (
        <p className={styles.error} role="alert">
          No pudimos descargar el ZIP. Intenta nuevamente.
        </p>
      )}
      <Button
        loading={state === 'downloading'}
        onClick={handleDownloadZip}
        fullWidth
      >
        ⬇ Descargar set completo (ZIP)
      </Button>
    </div>
  )
}
